import React from "react";
import { useTranslation } from "react-i18next";

type HalfCircleProgressProps = {
  percentage?: number; // 0–100
  size?: number;
  strokeWidth?: number;
};

const HalfCircleProgress: React.FC<HalfCircleProgressProps> = ({
  percentage=0,
  size = 120,
  strokeWidth = 10,
}) => {
  const radius = (size - strokeWidth) / 2;
  const centerX = size / 2;
  const centerY = size / 2;
  const startX = centerX - radius;
  const startY = centerY;
  const endX = centerX + radius;
  const endY = centerY;

  // path لرسم نصف دائرة من اليسار لليمين (من الأسفل)
  const d = `M ${startX} ${startY} A ${radius} ${radius} 0 0 1 ${endX} ${endY}`;

  // محيط نصف الدائرة فقط
  const halfCircumference = Math.PI * radius;
  const offset = halfCircumference - (percentage / 100) * halfCircumference;

   const {t} = useTranslation();

  return (
    <div className="shadow-custom-light bg-[#FFFFFF] rounded-2xl p-6 flex flex-col items-center">
        <svg width={size} height={size / 2} className="block">
            {/* الخلفية الرمادية */}
            <path
            d={d}
            fill="none"
            stroke="#EBF3F0"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            />
            {/* القوس الملون */}
            <path
            d={d}
            fill="none"
            stroke="#398C6E"
            strokeWidth={strokeWidth}
            strokeDasharray={halfCircumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            className="transition-all duration-500"
            />
            {/* النسبة */}
            <text
            x={centerX}
            y={centerY / 1.2}
            textAnchor="middle"
            className="text-[32px] font-black fill-Black"
            >
            {percentage}%
            </text>
        </svg>

        {/* النص تحت نصف الدائرة */}
        <p className="text-[14px] font-meduim text-Black mt-2 text-center">
            {t('customerRepeatRate')}
        </p>
        </div>

  );
};

export default HalfCircleProgress;
